/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/PenTool',['./Tool', '../shapes/PenShape', 'fabric'], function (Tool, PenShape) {
	'use strict';

	var PenTool = Tool.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			PenTool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {
			var pen = new PenShape({
				canvas: canvas,
				xCoord: xCoord,
				yCoord: yCoord,
				borderColor: this.borderColor,
				fillColor: this.fillColor
			});
			return pen;
		},

		activate: function activate(canvas, xCoord, yCoord) {
			canvas.isDrawingMode = true;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			canvas.freeDrawingBrush = new window.fabric.PencilBrush(canvas);
			if (canvas.freeDrawingBrush) {
				canvas.freeDrawingBrush.color = this.borderColor;
				canvas.freeDrawingBrush.width = 3;
			}
			canvas.selection = false;
			var cursor = this.newCursor(canvas, xCoord, yCoord);
			canvas.add(cursor);
			canvas.discardActiveObject().renderAll();
			canvas.getObjects().forEach(function (o) {
				o.set({
					selectable: false,
					editable: false,
					hasControls: false
				});
			});
			return cursor;
		},

		setColors: function setColors(canvas, colors) {
			// eslint-disable-line no-unused-vars
			PenTool.inherited('setColors', this, arguments);
			if (canvas.freeDrawingBrush) {
				canvas.freeDrawingBrush.color = this.borderColor;
				canvas.freeDrawingBrush.width = 3;
			}
		},

		canUpdate: function canUpdate() {
			return false;
		}

	});

	return PenTool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

